import { ChainLayer } from '@cronos-app/sdk';
const dexGraphqlUrls = {
    [ChainLayer.L2]: {
        dev: 'https://api.goldsky.com/api/public/project_clwrfupe2elf301wlhnd7bvva/subgraphs/h2-exchange-v2-cronos-zkevm-testnet/latest/gn',
        sta: 'https://api.goldsky.com/api/public/project_clwrfupe2elf301wlhnd7bvva/subgraphs/h2-exchange-v2-cronos-zkevm-testnet/latest/gn',
        prod: 'https://api.goldsky.com/api/public/project_clwrfupe2elf301wlhnd7bvva/subgraphs/h2-exchange-v2-cronos-zkevm/latest/gn',
        uat: 'https://api.goldsky.com/api/public/project_clwrfupe2elf301wlhnd7bvva/subgraphs/h2-exchange-v2-cronos-zkevm/latest/gn',
    },
    [ChainLayer.CronosEvm]: {
        dev: 'https://graph.cronoslabs.com/subgraphs/name/vvs/exchange-testnet',
        sta: 'https://graph.cronoslabs.com/subgraphs/name/vvs/exchange-testnet',
        prod: 'https://graph.cronoslabs.com/subgraphs/name/vvs/exchange',
        uat: 'https://graph.cronoslabs.com/subgraphs/name/vvs/exchange',
    },
};
export const getDexGraphqlEndpoint = (chainLayer) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const appEnv = process.env.APP_ENV ?? '';
    return dexGraphqlUrls[chainLayer][appEnv];
};
